module.exports = __webpack_public_path__ + "static/media/haimian-jinjixinfeizhizao.05166551.png";